import { Box, Button, Dialog } from '@mui/material';
import { Text, ButtonsContainer } from '..';
import { exclamation_circle_warning } from '@assets/icons';

interface IGuideModalProps {
  isVisible: boolean;
  onClick?: () => void;
  onClose: () => void;
  imgSrc?: string;
  title?: string;
  content: string;
  buttonText?: string;
  buttonVariant?: string;
  buttonCount?: number;
}

export const GuideModal = (props: IGuideModalProps) => {
  const {
    isVisible,
    onClick,
    onClose,
    imgSrc = `${exclamation_circle_warning}`,
    title = 'Oops!',
    content,
    buttonText = 'Yes',
    buttonVariant = 'contained',
    buttonCount = 1
  } = props;

  return (
    <Dialog
      open={isVisible}
      onClose={onClose}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.3)'
        },
        '& .MuiDialog-paper': {
          width: 512,
          maxHeight: 'calc(100% - 80px)',
          padding: '48px',
          boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.06)',
          borderRadius: 0
        }
      }}
    >
      <Box>
        <Box marginBottom="20px" display="flex" flexDirection="column" alignItems="center">
          <img src={imgSrc} alt="" width={60} height={60} style={{ marginBottom: '20px' }} />
          <Text variant="subtitle" fontWeight="bold" align="center" marginBottom="20px">
            {title}
          </Text>
          <Text variant="body1" align="center" style={{ whiteSpace: 'pre-line', minHeight: 40 }}>
            {content}
          </Text>
        </Box>

        {buttonCount === 1 ? (
          <Button
            variant={buttonVariant === 'contained' ? 'contained' : 'outlined'}
            color={buttonVariant === 'contained' ? 'primary' : 'secondary'}
            onClick={onClose}
            style={{ width: 416 }}
          >
            {buttonText}
          </Button>
        ) : (
          <ButtonsContainer variant="vertical">
            <Button variant="contained" color="primary" onClick={onClick} style={{ width: 416 }}>
              {buttonText}
            </Button>
            <Button variant="outlined" color="secondary" onClick={onClose} style={{ width: 416 }}>
              취소하기
            </Button>
          </ButtonsContainer>
        )}
      </Box>
    </Dialog>
  );
};
